import { gql } from '@apollo/client';
import { OFFER_TYPE_CODE } from '../components/shared/Constants';

const { PREPAY, POSTPAY } = OFFER_TYPE_CODE;
const QUERIES = {
  CREATE_ACQ: gql`
    mutation createAcquisitionProspect($offerType: String!) {
      createAcquisitionProspect(offerType: $offerType)
    }
  `,
};

export const createAcquisitionProspect = async ({ graphql }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.CREATE_ACQ,
    variables: { offerType: POSTPAY },
  });
  return data;
};

export const createAcquisitionProspectPrepay = async ({ graphql }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.CREATE_ACQ,
    variables: { offerType: PREPAY },
  });
  return data;
};
